import { useProvideSnackBar } from '../../hooks';
import { usePreconfiguredFetch } from '../../hooks/useProvidePreconfiguredFetch';
import React, { useState } from 'react';
import { Button, CardActions, CardContent, FormControl, Modal, TextField, Typography } from '@mui/material';
import { ConfirmCard } from '../Planner/Styles';
import ArrowBackIosNewTwoToneIcon from '@mui/icons-material/ArrowBackIosNewTwoTone';

type AddLineNameModalParams = {
    open: boolean;
    onClose: () => void;
    onDataChange: () => void;
    partnerId: number;
}

export default function AddLineNameModal({ open, onClose, onDataChange, partnerId }: AddLineNameModalParams) {
    const { showError, showSuccess, showResponseError } = useProvideSnackBar();
    const { fetchResource } = usePreconfiguredFetch();

    const [newLineName, setNewLineName] = useState<string>('')
    const [isLineNameError, setIsLineNameError] = useState<boolean>(false)


    const addLineName = async () => {
        if (newLineName?.trim().length === 0) {
            setIsLineNameError(true);
            return;
        }

        if (partnerId === 0) {
            return;
        }

        try {
            const response = await fetchResource(`/api/partners/${partnerId}/line_name`, {
                method: 'POST',
                body: JSON.stringify({
                    LineName: newLineName.trim(),
                }),
            });
            if (!response.ok) {
                showResponseError(response);
                return;
            }
            showSuccess('Sikeres mentés')
            onDataChange();

        } catch (error: any) {
            showError('Hiba történt: ' + error.message);
        } finally {
            onCloseModal();
        }
    }

    const onChangeHandler = (lineName: string) => {
        setNewLineName(lineName);
        setIsLineNameError(lineName?.trim().length === 0);
    }

    const onCloseModal = () => {
        setNewLineName('');
        setIsLineNameError(false);
        onClose();
    }

    return (
        <Modal open={open} onClose={onCloseModal} aria-labelledby="modal-title">
            <ConfirmCard>
                <CardContent sx={{ p: 2 }}>
                    <Typography variant="h6" component="h2" sx={{ marginBottom: 2 }} id="modal-title">
                        Járatnév hozzáadása
                    </Typography>
                    <FormControl fullWidth>
                        <TextField
                            value={newLineName}
                            placeholder='Járatnév'
                            variant='standard'
                            onChange={(e) => onChangeHandler(e.target.value as string)}
                            error={isLineNameError}
                            helperText={isLineNameError ? 'A járatnév megadása kötelező' : ''}
                        />
                    </FormControl>
                </CardContent>
                <CardActions sx={{ justifyContent: 'space-around' }}>
                    <Button
                        sx={{ borderRadius: 50 }}
                        variant={'outlined'}
                        size={'small'}
                        onClick={onCloseModal}
                        startIcon={<ArrowBackIosNewTwoToneIcon/>}>
                        Mégsem
                    </Button>
                    <Button variant='contained' size={'small'} sx={{ borderRadius: 50, minWidth: 100 }}
                            onClick={addLineName}>
                        Hozzáadás
                    </Button>
                </CardActions>
            </ConfirmCard>
        </Modal>
    )
}